module.exports = __webpack_public_path__ + "img/icon-suite.1bb43f01.png";